import PropTypes from 'prop-types';

import { Button, Dialog } from '@ctct/ui-react';

const InviteSentDialog = ({ t, onClose, email, isSsoAccount }) => {
  return (
    <Dialog
      data-qe-id="invite-sent-dialog"
      heading={t('invite_sent.heading')}
      isOpen
      footerActions={
        <Button
          text={t('invite_sent.primary_button')}
          kind="primary"
          onClick={onClose}
          data-qe-id="invite-sent-close-btn"
        />
      }
    >
      <p>{t('invite_sent.text1', { email })}</p>
      {isSsoAccount && (
        <p>
          {t('invite_sent.sso_expiry_prefix')}
          <strong>{t('invite_sent.sso_expiry_duration')}</strong>
        </p>
      )}
    </Dialog>
  );
};

InviteSentDialog.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  isSsoAccount: PropTypes.bool,
};

InviteSentDialog.defaultProps = {
  isSsoAccount: false,
};

export default InviteSentDialog;
